/**
 * Packaging OS — 404.
 */

import { useNavigate } from "react-router-dom";
import { Button } from "../components/Button";
import { Footer } from "../components/Footer";
import { PublicHeader } from "../components/PublicHeader";
import { strings } from "../i18n/strings";
import { useLocale } from "../i18n/useLocale";
import { useLocaleSwitch } from "../i18n/useLocaleSwitch";

export function NotFoundPage(): JSX.Element {
  const [locale] = useLocale();
  const setLocale = useLocaleSwitch();
  const t = strings(locale);
  const navigate = useNavigate();

  return (
    <div className="po-page">
      <PublicHeader
        locale={locale}
        onLocaleChange={setLocale}
        switchLanguageLabel={t.switchLanguageLabel}
        brand={t.appName}
        navLinks={[{ to: "/", label: t.ctaBackToLanding }]}
      />

      <main className="po-page-main po-page-main--error">
        <header className="po-section-header">
          <h1 className="po-section-header__title">{t.notFoundTitle}</h1>
        </header>
        <p className="po-note">{t.notFoundBody}</p>
        <div className="po-row">
          <Button variant="primary" onClick={() => navigate("/")}>
            {t.ctaBackToLanding}
          </Button>
        </div>
      </main>

      <Footer copyright={t.copyrightLine} />
    </div>
  );
}
